// 006 (FR-014; research R9; data-model §6): one place that asks before leaving unsaved work. The
// class card registers `confirm` while it has unsaved edits; navigation, Change school, Switch to
// parent and Log out run through `runGuarded`. Shell code, free of school-admin imports.
type Confirm = () => Promise<boolean>;

let current: Confirm | null = null;

/** Registers the guard; returns the function that removes it (only if it is still the current one). */
export function registerLeaveGuard(confirm: Confirm): () => void {
  current = confirm;
  return () => {
    if (current === confirm) current = null;
  };
}

export function hasLeaveGuard(): boolean {
  return current !== null;
}

/** Runs `action` at once without a guard, otherwise only after the guard confirms. */
export async function runGuarded(
  action: () => void | Promise<void>,
): Promise<boolean> {
  if (current !== null && !(await current())) return false;
  await action();
  return true;
}
